/* eslint-disable max-len */
import { mapActions } from 'vuex';
import jApiFormUi from '@/services/jApiFormUi';

export default {
  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
  },

  watch: {
    dataComponent(val) {
      this.componentInfo = JSON.parse(val.info);
      this.formUiId = this.isMultipleUi && this.forDetailParent ? this.componentInfo.multiple_form_ui_id : this.componentInfo.form_ui_id;
      this.titleComponent = val.name;

      this.getDetailComponent();
    },
  },

  data() {
    return {
      isLoading: true,
      componentInfo: null,
      titleComponent: '',
      titleView: '',
      formUiId: '',
      detailComponent: null,
    };
  },

  computed: {
    isMultipleUi() {
      return this.dataComponent.type === 'multiple_form_ui';
    },
  },

  created() {
    if (this.dataComponent) {
      if (!this.forCanvas) {
        this.componentInfo = JSON.parse(this.dataComponent.info);
        this.formUiId = this.isMultipleUi && this.forDetailParent ? this.componentInfo.multiple_form_ui_id : this.componentInfo.form_ui_id;
        this.titleComponent = this.dataComponent.name;

        this.getDetailComponent();
      } else {
        this.formUiId = this.dataComponent.form_ui_id;
        this.getDetailComponent();
      }
    }
  },

  methods: {
    ...mapActions('jStoreFormUi', ['actionGetSetupFormUi']),

    // eslint-disable-next-line consistent-return
    async requestDataComponent() {
      if (!this.forCanvas) {
        const param = {
          limit: 0,
          page: 1,
          filter: JSON.stringify({
            id: this.formUiId,
          }),
        };

        const request = this.isMultipleUi ? jApiFormUi.listMultiForm : jApiFormUi.listForm;
        const response = await request(param);

        return response;
      } else if (this.forCanvas) {
        const param = {
          page: 1,
          limit: 1,
          filter: {
            id: [this.formUiId],
          },
        };
        const response = await this.actionGetSetupFormUi(param);
        return response;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-ui-v2/jMixComponentMultiDetailView.js